export const CAROUSEL_TRANSITION = [
  {
    type: 'NONE',
    name: 'None',
    buttonImg: '/images/carouselTransitions/none.png'
  },
  // {
  //   type: 'HORIZONTAL',
  //   name: 'Horizontal',
  //   buttonImg: '/images/carouselTransitions/horizontal.png'
  // },
  // {
  //   type: 'VERTICAL',
  //   name: 'Vertical',
  //   buttonImg: '/images/carouselTransitions/vertical.png'
  // },
  {
    type: 'FADE',
    name: 'Fade',
    buttonImg: '/images/carouselTransitions/fade.png'
  },
  // {
  //   type: 'DISSOLVE',
  //   name: 'Dissolve',
  //   buttonImg: '/images/carouselTransitions/dissolve.png'
  // },
]

export const CAROUSEL_ARROWS = [
  {
    type: 'MORDERN',
    name: 'mordern'
  },
  {
    type: 'STANDARD',
    name: 'standard'
  },
  {
    type: 'DEFAULT',
    name: 'default'
  }
]

export const CAROUSEL_DOTS = [

  {
    type: 'DEFAULT',
    name: 'default'
  },
  {
    type: 'STANDARD',
    name: 'standard'
  }
  // {
  //   type: 'MORDERN',
  //   name: 'mordern'
  // },
]